var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteLeftSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 54,
    viewBox: "0 0 47 54",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.7812C0 15.7887 5.63371 10.125 12.5893 10.125H13.4286C15.2855 10.125 16.7857 11.6332 16.7857 13.5C16.7857 15.3668 15.2855 16.875 13.4286 16.875H12.5893C9.34754 16.875 6.71429 19.5223 6.71429 22.7812V23.625H13.4286C17.1319 23.625 20.1429 26.652 20.1429 30.375V37.125C20.1429 40.848 17.1319 43.875 13.4286 43.875H6.71429C3.01094 43.875 0 40.848 0 37.125V33.75V30.375V22.7812ZM26.8571 22.7812C26.8571 15.7887 32.4908 10.125 39.4464 10.125H40.2857C42.1426 10.125 43.6429 11.6332 43.6429 13.5C43.6429 15.3668 42.1426 16.875 40.2857 16.875H39.4464C36.2047 16.875 33.5714 19.5223 33.5714 22.7812V23.625H40.2857C43.9891 23.625 47 26.652 47 30.375V37.125C47 40.848 43.9891 43.875 40.2857 43.875H33.5714C29.8681 43.875 26.8571 40.848 26.8571 37.125V33.75V30.375V22.7812Z",
    fill: "#1F4999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteLeftSolid);
export default __webpack_public_path__ + "static/media/quote-left-solid.e22c2561b584b9ce61fcf27fcf71442e.svg";
export { ForwardRef as ReactComponent };